// extracted by mini-css-extract-plugin
export default {"root":"Speech_root__yhjsO","videoHolder":"Speech_videoHolder__714Ew","buttonGroup":"Speech_buttonGroup__SXmXq","inner":"Speech_inner__Z3fLK"};